import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ontos-field-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_instance_reverse_rel_input = _resolveComponent("ontos-instance-reverse-rel-input")!
  const _component_number_input = _resolveComponent("number-input")!
  const _component_ontos_media_field = _resolveComponent("ontos-media-field")!
  const _component_markdown_viewer = _resolveComponent("markdown-viewer")!
  const _component_markdown_editor = _resolveComponent("markdown-editor")!
  const _component_v_messages = _resolveComponent("v-messages")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_ontos_choice_input = _resolveComponent("ontos-choice-input")!
  const _component_ontos_person_select = _resolveComponent("ontos-person-select")!
  const _component_ontos_rel_option = _resolveComponent("ontos-rel-option")!
  const _component_ontos_rel_selection = _resolveComponent("ontos-rel-selection")!
  const _component_ontos_creatable_autocomplete = _resolveComponent("ontos-creatable-autocomplete")!
  const _component_multiple_field = _resolveComponent("multiple-field")!
  const _component_ontos_boolean_input = _resolveComponent("ontos-boolean-input")!
  const _component_ontos_field_failures = _resolveComponent("ontos-field-failures")!
  const _component_create_instance_dialog = _resolveComponent("create-instance-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.property.relationship && _ctx.property.relationship.reverse)
      ? (_openBlock(), _createBlock(_component_ontos_instance_reverse_rel_input, {
          key: 0,
          ref: "reverseInput",
          property: _ctx.property,
          value: _ctx.shownValue,
          loading: _ctx.pending,
          items: _ctx.offeredDomain,
          "reverse-info": _ctx.reverseInfo,
          "idea-alias": _ctx.ideaAlias,
          "instance-id": _ctx.instanceId,
          "system-alias": _ctx.systemAlias,
          readonly: _ctx.readonly || !_ctx.reverseInfo,
          "error-message": _ctx.errorMessage,
          hint: _ctx.guidance,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('input', $event))),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change', $event))),
          onShowMessage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('showMessage', $event)))
        }, null, 8, ["property", "value", "loading", "items", "reverse-info", "idea-alias", "instance-id", "system-alias", "readonly", "error-message", "hint"]))
      : (!_ctx.property.multiple && _ctx.property.type === 'number' && !_ctx.property.formula)
        ? (_openBlock(), _createBlock(_component_number_input, {
            key: 1,
            style: _normalizeStyle([{"flex-basis":"auto"}, _ctx.numberWidth(_ctx.property)]),
            class: _normalizeClass(_ctx.applyClass),
            type: _ctx.property.subtype,
            label: _ctx.property.name,
            value: _ctx.$utils.isNullOrUndefined(_ctx.value)? undefined : Number(_ctx.value),
            readonly: _ctx.readonly,
            onInput: _cache[3] || (_cache[3] = ($event: any) => (
              _ctx.$emit('input', Number($event))
            )),
            onBlur: _cache[4] || (_cache[4] = ($event: any) => (
              _ctx.$emit('change', _ctx.value)
            )),
            counter: _ctx.property.length,
            onKeydown: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('keydown', $event))),
            "error-message": _ctx.errorMessage
          }, null, 8, ["class", "type", "style", "label", "value", "readonly", "counter", "error-message"]))
        : (_ctx.isMediaType(_ctx.property))
          ? (_openBlock(), _createBlock(_component_ontos_media_field, {
              key: 2,
              type: _ctx.property.type,
              value: _ctx.value,
              label: _ctx.property.name,
              readonly: _ctx.readonly,
              class: _normalizeClass(_ctx.applyClass),
              "error-message": _ctx.errorMessage,
              onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('input', $event))),
              onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('change', $event)))
            }, null, 8, ["type", "value", "label", "readonly", "class", "error-message"]))
          : (_ctx.property.type === 'text' && _ctx.property.subtype === 'markdown')
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: _normalizeClass(_ctx.applyClass)
              }, [
                _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.property.name), 1),
                (_ctx.readonly)
                  ? (_openBlock(), _createBlock(_component_markdown_viewer, {
                      key: 0,
                      initialValue: _ctx.shownMarkdown(_ctx.value, _ctx.workspace, _ctx.item || undefined, _ctx.ideaAlias)
                    }, null, 8, ["initialValue"]))
                  : (_openBlock(), _createBlock(_component_markdown_editor, {
                      key: 1,
                      initialEditType: "wysiwyg",
                      mentions: "",
                      item: _ctx.item,
                      "idea-alias": _ctx.ideaAlias,
                      onChange: _ctx.onChangeMarkdown,
                      onShowMessage: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('showMessage', $event))),
                      ref: "markdown-editor"
                    }, null, 8, ["item", "idea-alias", "onChange"])),
                (_ctx.errorMessage)
                  ? (_openBlock(), _createBlock(_component_v_messages, {
                      key: 2,
                      active: "",
                      messages: _ctx.errorMessage,
                      color: "error",
                      class: "mt-1",
                      role: "alert"
                    }, null, 8, ["messages"]))
                  : _createCommentVNode("", true)
              ], 2))
            : (_ctx.computedAsText)
              ? (_openBlock(), _createBlock(_component_v_text_field, {
                  key: 4,
                  class: _normalizeClass(_ctx.applyClass),
                  readonly: "",
                  "model-value": _ctx.pending ? '' : _ctx.computedText,
                  loading: _ctx.pending,
                  label: _ctx.property.name,
                  onKeydown: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('keydown', $event)))
                }, null, 8, ["class", "model-value", "loading", "label"]))
              : (_ctx.property.type === 'choice')
                ? (_openBlock(), _createBlock(_component_ontos_choice_input, {
                    key: 5,
                    label: _ctx.property.name,
                    value: _ctx.shownValue,
                    options: _ctx.offeredOptions,
                    multiple: !!_ctx.property.multiple,
                    readonly: _ctx.readonly,
                    loading: _ctx.pending,
                    disabled: _ctx.pending,
                    required: _ctx.required,
                    class: _normalizeClass(_ctx.applyClass),
                    "error-message": _ctx.errorMessage,
                    hint: _ctx.guidance,
                    onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('change', $event)))
                  }, null, 8, ["label", "value", "options", "multiple", "readonly", "loading", "disabled", "required", "class", "error-message", "hint"]))
                : (_ctx.property.type === 'user')
                  ? (_openBlock(), _createBlock(_component_ontos_person_select, {
                      key: 6,
                      people: _ctx.offeredPeople,
                      label: _ctx.property.name,
                      "model-value": _ctx.shownValue,
                      multiple: !!_ctx.property.multiple,
                      readonly: _ctx.readonly,
                      loading: _ctx.pending,
                      disabled: _ctx.pending,
                      clearable: _ctx.clearable,
                      "menu-icon": _ctx.menuIconOf(_ctx.readonly),
                      class: _normalizeClass(_ctx.applyClass),
                      "error-messages": _ctx.errorMessage,
                      hint: _ctx.guidance,
                      "persistent-hint": !!_ctx.guidance,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('change', $event)))
                    }, null, 8, ["people", "label", "model-value", "multiple", "readonly", "loading", "disabled", "clearable", "menu-icon", "class", "error-messages", "hint", "persistent-hint"]))
                  : (_ctx.isOwnedRelationship(_ctx.property))
                    ? (_openBlock(), _createBlock(_component_ontos_creatable_autocomplete, {
                        key: 7,
                        label: _ctx.property.name,
                        items: _ctx.offeredDomain.map(domainInstance => domainInstance.name? domainInstance :
                          _ctx.$copy.shallowCopy(domainInstance, {name: `${_ctx.property.relationship.idea} #${domainInstance._instance}`})),
                        "item-title": "_identifier",
                        class: _normalizeClass(_ctx.applyClass),
                        "item-value": "_instance",
                        readonly: _ctx.readonly,
                        loading: _ctx.pending,
                        disabled: _ctx.pending,
                        "menu-icon": _ctx.menuIconOf(_ctx.readonly),
                        multiple: _ctx.property.multiple,
                        "auto-select-first": "",
                        "error-messages": _ctx.errorMessage,
                        hint: _ctx.guidance,
                        "persistent-hint": !!_ctx.guidance,
                        "model-value": _ctx.relValue(_ctx.property),
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('input', _ctx.keepFixed($event)))),
                        onBlur: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('change', _ctx.value))),
                        onCreate: _cache[15] || (_cache[15] = ($event: any) => (_ctx.openCreateRel({property: _ctx.property, name: $event})))
                      }, {
                        item: _withCtx(({item, props}) => [
                          _createVNode(_component_ontos_rel_option, _mergeProps(props, { item: item }), null, 16, ["item"])
                        ]),
                        selection: _withCtx(({item}) => [
                          _createVNode(_component_ontos_rel_selection, {
                            item: item,
                            removable: _ctx.property.multiple ? !_ctx.readonly && !_ctx.isFixed(item) : _ctx.clearable,
                            onRemove: _cache[12] || (_cache[12] = ($event: any) => (_ctx.remove($event)))
                          }, null, 8, ["item", "removable"])
                        ]),
                        _: 1
                      }, 8, ["label", "items", "class", "readonly", "loading", "disabled", "menu-icon", "multiple", "error-messages", "hint", "persistent-hint", "model-value"]))
                    : (_ctx.property.multiple)
                      ? (_openBlock(), _createBlock(_component_multiple_field, {
                          key: 8,
                          value: _ctx.value,
                          type: _ctx.property.type,
                          class: _normalizeClass(_ctx.applyClass),
                          subtype: _ctx.property.subtype,
                          "error-message": _ctx.errorMessage,
                          onInput: _cache[16] || (_cache[16] = ($event: any) => (
              _ctx.$emit('input', $event)
            )),
                          onBlur: _cache[17] || (_cache[17] = ($event: any) => (
              _ctx.$emit('change', _ctx.value)
            )),
                          label: _ctx.property.name
                        }, null, 8, ["value", "type", "class", "subtype", "error-message", "label"]))
                      : (_ctx.property.type === 'boolean')
                        ? (_openBlock(), _createBlock(_component_ontos_boolean_input, {
                            key: 9,
                            class: _normalizeClass(_ctx.applyClass),
                            label: _ctx.property.name,
                            value: _ctx.shownValue,
                            required: _ctx.required,
                            readonly: _ctx.readonly,
                            loading: _ctx.pending,
                            "error-message": _ctx.errorMessage,
                            onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('change', $event)))
                          }, null, 8, ["class", "label", "value", "required", "readonly", "loading", "error-message"]))
                        : (_openBlock(), _createBlock(_component_v_text_field, {
                            key: 10,
                            style: _normalizeStyle([{"flex-basis":"auto"}, _ctx.numberWidth(_ctx.property)]),
                            type: _ctx.property.type,
                            label: _ctx.property.name,
                            "model-value": _ctx.value,
                            readonly: _ctx.readonly,
                            class: _normalizeClass(_ctx.applyClass),
                            placeholder: _ctx.property.type === 'date'? new Date().toISOString() : undefined,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.onTyped($event))),
                            onBlur: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onLeft())),
                            counter: _ctx.property.length,
                            onKeydown: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$emit('keydown', $event))),
                            "error-messages": _ctx.errorMessage
                          }, null, 8, ["type", "style", "label", "model-value", "readonly", "class", "placeholder", "counter", "error-messages"])),
    _createVNode(_component_ontos_field_failures, {
      failures: _ctx.warnings,
      class: _normalizeClass({'warnings-in-details': _ctx.reservesDetails})
    }, null, 8, ["failures", "class"]),
    (_ctx.createRel && _ctx.createRelContext)
      ? (_openBlock(), _createBlock(_component_create_instance_dialog, {
          key: 11,
          ref: "createRel",
          context: _ctx.createRelContext,
          initialName: _ctx.createRelName,
          "full-page": false,
          onShowMessage: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$emit('showMessage', $event))),
          onSaved: _ctx.onSavedRel,
          onClosed: _ctx.closeRel
        }, null, 8, ["context", "initialName", "onSaved", "onClosed"]))
      : _createCommentVNode("", true)
  ]))
}